/**
 * Combined RFIs tour: list view → click a row → detail view.
 *
 * Primary tour for users who have at least one RFI — walks the entire
 * feature in one continuous run. The transition step
 * (``combinedTableStep``) clicks the first row, navigates to the detail
 * page, and waits for it to mount before the detail steps take over.
 *
 * For users with no RFIs yet, see ``list.ts``. For users who land on a
 * detail page directly, see ``detail.ts``. ``RfisPage`` / ``RfiDetail``
 * pick which one is appropriate based on ``hasSeen`` + project state.
 */
import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import { RFIS_LIST_TOUR_ID } from './list';
import { RFIS_DETAIL_TOUR_ID } from './detail';
import {
  assignmentStep,
  attachmentsStep,
  combinedTableStep,
  commentsStep,
  filtersStep,
  headerActionsStep,
  metadataStep,
  newRfiStep,
  questionStep,
  responseStep,
  widgetsStep,
} from './steps';

export const RFIS_COMBINED_TOUR_ID = 'rfis.combined';

registerTour({
  id: RFIS_COMBINED_TOUR_ID,
  name: 'RFIs',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.RFIS.id,
  // Completing the combined tour also marks list-only and detail-only
  // tours as seen — they cover the same content this tour walked.
  alsoMarks: [RFIS_LIST_TOUR_ID, RFIS_DETAIL_TOUR_ID],
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to RFIs',
      body:
        'Track Requests For Information across your project. We\u2019ll ' +
        'walk through the list view and then dive into one RFI.',
    },
    newRfiStep,
    widgetsStep,
    filtersStep,
    combinedTableStep,
    headerActionsStep,
    metadataStep,
    questionStep,
    responseStep,
    commentsStep,
    attachmentsStep,
    assignmentStep,
  ],
});
